export default __webpack_public_path__ + "static/media/grid.001.8512dd4e.jpeg";